module.exports = {
	'通用':{
		'实时监控':"实时监控",
		'实时定位':'实时定位',
		'实时定位2D':'实时定位2D',
		'实时定位2.5D':'实时定位2.5D',
		'实时追踪':'实时追踪',
		'实时追踪2.5D':'实时追踪2.5D',
		'风险分区':'风险分区',
		'风险分区2D':'风险分区2D',
		'风险分区2.5D':'风险分区2.5D',
		'热力图':'热力图',
		'热力图2D':'热力图2D',
		'热力图2.5D':'热力图2.5D',
		'轨迹查询':'轨迹查询',
		'人员轨迹':'人员轨迹',
		'车辆轨迹':'车辆轨迹',
		'报警管理':'报警管理',
		'人员报警记录':'人员报警记录',
		'车辆报警记录':'车辆报警记录',
		'人员管理':'人员管理',
		'员工管理':'员工管理',
		'访客管理':'访客管理',
		'承包商管理':'承包商管理',
		'人员列表':'人员列表',
		'设备管理':'设备管理',
		'定位卡管理':'定位卡管理',
		'信标管理':'信标管理',
		'信标管理2D':'信标管理2D',
		'信标管理2.5D':'信标管理2.5D',
		'基站管理':'基站管理',
		'基站管理2D':'基站管理2D',
		'基站管理2.5D':'基站管理2.5D',
		'楼宇管理':'楼宇管理',
		'楼层管理':'楼层管理',
		'摄像头管理':'摄像头管理',
		'摄像头管理2D':'摄像头管理2D',
		'摄像头管理2.5D':'摄像头管理2.5D',
		'车辆卡管理':'车辆卡管理',
		'车辆通行记录':'车辆通行记录',
		'围栏管理':'围栏管理',
		'电子围栏':'电子围栏',
		'电子围栏2D':'电子围栏2D',
		'电子围栏2.5D':'电子围栏2.5D',
		'人员报警设置':'人员报警设置',
		'车辆报警设置':'车辆报警设置',
		'报警通知设置':'报警通知设置',
		'SOS报警通知设置':'SOS报警通知设置',
		'区域管理':'区域管理',
		'区域列表':'区域列表',
		'重大风险分区管理':'重大风险分区管理',
		'单区列表':'单区列表',
		'新增单区列表':'新增单区列表',
		'信标分组':'信标分组',
		'统计管理':'统计管理',
		'人员统计':'人员统计',
		'报警统计':'报警统计',
		'二道门进出记录':'二道门进出记录',
		'考勤记录':'考勤记录',
		'人员分布统计':'人员分布统计',
		'人员分布统计2.5D':'人员分布统计2.5D',
		'智能巡检':'智能巡检',
		'巡检项管理':'巡检项管理',
		'巡检点管理':'巡检点管理',
		'巡检类别管理':'巡检类别管理',
		'巡检班组管理':'巡检班组管理',
		'巡检路线管理':'巡检路线管理',
		'巡检记录':'巡检记录',
		'隐患管理':'隐患管理',
		'巡检统计':'巡检统计',
		'作业安全':'作业安全',
		'JSA作业安全分析':'JSA作业安全分析',
		'作业活动预约':'作业活动预约',
		'作业申请':'作业申请',
		'待办审批':'待办审批',
		'作业列表':'作业列表',
		'作业管理库':'作业管理库',
		'作业字典管理':'作业字典管理',
		'作业配置管理':'作业配置管理',
		'作业审批库':'作业审批库',
		'风险识别管理':'风险识别管理',
		'安全措施管理':'安全措施管理',
		'应急措施管理':'应急措施管理',
		'JSA分析库':'JSA分析库',
		'作业监护':'作业监护',
		'AI智能分析设备':'AI智能分析设备',
		'监控设备管理':'监控设备管理',
		'监控报警记录':'监控报警记录',
		'应急演练':'应急演练',
		'演练计划':'演练计划',
		'演练记录':'演练记录',
		'权限管理':'权限管理',
		'菜单管理':'菜单管理',
		'角色管理':'角色管理',
		'用户管理':'用户管理',
		'部门管理':'部门管理',
		'岗位管理':'岗位管理',
		'系统管理':'系统管理',
		'地图配置':'地图配置',
		'系统信息':'系统信息',
		'字典管理':'字典管理',
		'系统配置':'系统配置',
		'大屏配置':'大屏配置',
		'登录日志':'登录日志',
		'操作日志':'操作日志',
		'版本日志':'版本日志',
		'首页':'首页',
		'定位追踪':'定位追踪',
		'历史轨迹':'历史轨迹',
		'安全作业':'安全作业',
		'应急救援':'应急救援',
		'新增':'新 增',
		'编辑':'编辑',
		'智能灯控':'智能灯控',
		'灯具管理':'灯具管理',
		'灯组管理':'灯组管理',
		'时控任务':'时控任务',
		'异常报警记录':'异常报警记录',
		'灯具功耗统计':'灯具功耗统计',
		'不能为空':'不能为空',
		'员工登录':'员工登录',
		'管理员登录':'管理员登录',
		'登录':'登录',
		'记住密码':'记住密码',
		'换一张':'换一张',
		'搜索姓名、卡号':'搜索姓名、卡号',
		'请输入要查询的车辆':'请输入要查询的车辆',
		'请选择部门':'请选择部门',
		'选择部门':'选择部门',
		'选择报警类型':'选择报警类型',
		'选择处理状态':'选择处理状态',
		'开始日期':'开始日期',
		'结束日期':'结束日期',
		'报警区域名':'报警区域名',
		'定位卡号':'定位卡号',
		'人员姓名':'人员姓名',
		'请输入工号':'请输入工号',
		'姓名':'姓名',
		'工号':'工号',
		'性别':'性别',
		'籍贯':'籍贯',
		'健康状态':'健康状态',
		'民族':'民族',
		'出生日期':'出生日期',
		'政治面貌':'政治面貌',
		'联系方式':'联系方式',
		'证件类型':'证件类型',
		'员工类别':'员工类别',
		'证件号码':'证件号码',
		'所属部门':'所属部门',
		'婚姻状态':'婚姻状态',
		'所属岗位':'所属岗位',
		'入职日期':'入职日期',
		'职称':'职称',
		'最高学位':'最高学位',
		'职称证书编号':'职称证书编号',
		'最高学历':'最高学历',
		'工龄':'工龄',
		'专业':'专业',
		'办公电话':'办公电话',
		'毕业证书号':'毕业证书号',
		'邮箱':'邮箱',
		'毕业院校':'毕业院校',
		'3年以上化工行业经验':'3年以上化工行业经验',
		'注册工程师证编号':'注册工程师证编号',
		'工作职责':'工作职责',
		'工作经历':'工作经历',
		'照片':'照片',
		'附件':'附件',
		'备注':'备注',
		'男':'男',
		'女':'女',
		'是':'是',
		'否':'否',
		'选择日期':'选择日期',
		'接待人':'接待人',
		'接待人联系方式':'接待人联系方式',
		'访客所在单位名称':'访客所在单位名称',
		'请输入单位名称':'请输入单位名称',
		'单位名称':'单位名称',
		'类别':'类别',
		'行业类型':'行业类型',
		'法人':'法人',
		'联系人':'联系人',
		'经营范围':'经营范围',
		'联系电话':'联系电话',
		'营业执照':'营业执照',
		'请选择人员类型':'请选择人员类型',
		'请输入电量值':'请输入电量值',
		'请选择状态':'请选择状态',
		'请输入定位卡号':'请输入定位卡号',
		'请选择使用状态':'请选择使用状态',
		'请选择启用状态':'请选择启用状态',
		'请选择定位卡类型':'请选择定位卡类型',
		'请输入IC卡号':'请输入IC卡号',
		'IC卡号':'IC卡号',
		'卡类型':'卡类型',
		'状态':'状态',
		'定位卡':'定位卡',
		'智能手表':'智能手表',
		'启用':'启用',
		'禁用':'禁用',
		'移动电话':'移动电话',
		'身份证号':'身份证号',
		'进场日期':'进场日期',
		'离场日期':'离场日期',
		'职务':'职务',
		'请输入信标编码':'请输入信标编码',
		'全部':'全部',
		'请输入基站编码':'请输入基站编码',
		'请选择基站类型':'请选择基站类型',
		'基站编码':'基站编码',
		'基站类型':'基站类型',
		'IP地址':'IP地址',
		'端口号':'端口号',
		'操作':'操作',
		'请输入楼宇名称':'请输入楼宇名称',
		'经度':'经度',
		'纬度':'纬度',
		'高度':'高度',
		'使用状态':'使用状态',
		'启用状态':'启用状态',
		'楼宇名称':'楼宇名称',
		'请输入楼层名称':'请输入楼层名称',
		'楼层名称':'楼层名称',
		'地图类型':'地图类型',
		'文件':'文件',
		'楼层简称':'楼层简称',
		'移速（米/秒）':'移速（米/秒）',
		'最大经度':'最大经度',
		'最小经度':'最小经度',
		'最大纬度':'最大纬度',
		'最小纬度':'最小纬度',
		'视角高度':'视角高度',
		'工具':'工具',
		'设置':'设置',
		'通过工具绘制区域会自动取出绘制区域的最大最小坐标和视角高度':'通过工具绘制区域会自动取出绘制区域的最大最小坐标和视角高度',
		'请输入摄像头名称':'请输入摄像头名称',
		'请输入所属楼层':'请输入所属楼层',
		'请输入ip地址':'请输入ip地址',
		'摄像头名称':'摄像头名称',
		'RTSP流地址':'RTSP流地址',
		'ip地址':'ip地址',
		'所属楼层':'所属楼层',
		'请输入车辆编码':'请输入车辆编码',
		'请输入车牌号':'请输入车牌号',
		'请输入司机姓名':'请输入司机姓名',
		'请输入SN码':'请输入SN码',
		'车辆编码':'车辆编码',
		'SN码':'SN码',
		'车辆名称':'车辆名称',
		'车辆类型':'车辆类型',
		'车牌号':'车牌号',
		'限速(Km/h)':'限速(Km/h)',
		'司机姓名':'司机姓名',
		'司机手机号':'司机手机号',
		'电量（%）':'电量（%）',
		'设备状态':'设备状态',
		'在线状态':'在线状态',
		'序号':'序号',
		'记录时间':'记录时间',
		'请输入围栏名称':'请输入围栏名称',
		'围栏名称':'围栏名称',
		'当前位置':'当前位置',
		'请输入报警设置名称':'请输入报警设置名称',
		'请选择报警类型':'请选择报警类型',
		'围栏':'围栏',
		'例外人员':'例外人员',
		'报警通知':'报警通知',
		'报警类型':'报警类型',
		'生效日期':'生效日期',
		'生效时间':'生效时间',
		'报警规则(秒/人)':'报警规则(秒/人)',
		'部门':'部门',
		'绑定车辆':'绑定车辆',
		'报警通知名称':'报警通知名称',
		'通知类型':'通知类型',
		'一级接收者人员':'一级接收者人员',
		'二级接收者人员':'二级接收者人员',
		'三级接收者人员':'三级接收者人员',
		'是否启用':'是否启用',
		'第一时间接收到信息':'第一时间接收到信息',
		'请设置':'请设置',
		'分钟后接收到信息':'分钟后接收到信息',
		'短信通知':'短信通知',
		'报警通知提示':'报警通知提示',
		'报警通知提示内容':'如果报警状态为“已处理”，则不会继续发送通知；如果报警状态为“未处理”，则会按照配置时间依次通知分级接收者；',
		'请填写区域名称':'请填写区域名称',
		'区域名称':'区域名称',
		'员工':'员工',
		'访客':'访客',
		'承包商':'承包商',
		'车辆':'车辆',
		'序列':'序列',
		'部门名称':'部门名称',
		'日期':'日期',
		'总数':'总数',
		'未处理':'未处理',
		'SOS报警':'SOS报警',
		'进入报警':'进入报警',
		'越界报警':'越界报警',
		'滞留报警':'滞留报警',
		'缺员报警':'缺员报警',
		'超员报警':'超员报警',
		'静止报警':'静止报警',
		'低电报警':'低电报警',
		'超速报警':'超速报警',
		'今日人员数据概览':'今日人员数据概览',
		'人':'人',
		'较昨日':'较昨日',
		'较上周同日':'较上周同日',
		'人员流量数据统计':'人员流量数据统计',
		'员工占比':'员工占比',
		'部门统计':'部门统计',
		'在线':'在线',
		'离线':'离线',
		'绑定':'绑定',
		'未绑定':'未绑定',
		'近7天':'近7天',
		'近30天':'近30天',
		'次':'次',
		'今日报警数据概览':'今日报警数据概览',
		'高发报警区域统计':'高发报警区域统计',
		'报警人员统计':'报警人员统计',
		'报警类型统计':'报警类型统计',
		'报警数量走势图':'报警数量走势图',
		'时间段查询':'时间段查询',
		'位置':'位置',
		'人员类型':'人员类型',
		'进出类型':'进出类型',
		'类型':'类型',
		'打卡时间':'打卡时间',
		'请输入巡检项名称':'请输入巡检项名称',
		'巡检项内容':'巡检项内容',
		'参数名称':'参数名称',
		'阈值（下限）':'阈值（下限）',
		'阈值（上限）':'阈值（上限）',
		'单位':'单位',
		'添加设备参数':'添加设备参数',
		'请输入巡检点名称':'请输入巡检点名称',
		'巡检点名称':'巡检点名称',
		'巡检点编码':'巡检点编码',
		'巡检点类型':'巡检点类型',
		'所属区域':'所属区域',
		'巡检点状态':'巡检点状态',
		'负责人':'负责人',
		'经纬度':'经纬度',
		'定位点':'定位点',
		'巡检点查看':'巡检点查看',
		'关联巡检项':'关联巡检项',
		'请输入巡检类别名称':'请输入巡检类别名称',
		'巡检类别':'巡检类别',
		'检查方式':'检查方式',
		'检查内容':'检查内容',
		'依据':'依据',
		'请输入巡检班次名称':'请输入巡检班次名称',
		'巡检班次名称':'巡检班次名称',
		'巡检组长':'巡检组长',
		'巡检人员':'巡检人员',
		'开始时间':'开始时间',
		'结束时间':'结束时间',
		'巡检路线名称':'巡检路线名称',
		'巡检点':'巡检点',
		'巡检周期':'巡检周期',
		'巡检时间':'巡检时间',
		'巡检班组':'巡检班组',
		'巡检负责人':'巡检负责人',
		'新增巡检点':'新增巡检点',
		'添加巡检时间':'添加巡检时间',
		'*注:可通过拖拽巡检点改变顺序。':'*注:可通过拖拽巡检点改变顺序。',
		'任务状态':'任务状态',
		'巡检状态':'巡检状态',
		'巡检人':'巡检人',
		'巡检点数':'巡检点数',
		'完成点数':'完成点数',
		'隐患数量':'隐患数量',
		'创建时间':'创建时间',
		'完成时间':'完成时间',
		'身份':'身份',
		'签名':'签名',
		'巡检结果':'巡检结果',
		'完成状态':'完成状态',
		'巡检完成时间':'完成时间',
		'巡检反馈':'巡检反馈',
		'巡检项状态':'巡检项状态',
		'采集值':'采集值',
		'阈值':'阈值',
		'采集状态':'采集状态',
		'异常巡检项':'异常巡检项',
		'审核信息':'审核信息',
		'整改信息':'整改信息',
		'验收信息':'验收信息',
		'隐患状态':'隐患状态',
		'隐患上传时间':'隐患上传时间',
		'检查项':'检查项',
		'审核人':'审核人',
		'审核时间':'审核时间',
		'审核值':'审核值',
		'审核描述':'审核描述',
		'审核结果':'审核结果',
		'审核反馈':'审核反馈',
		'整改期限':'整改期限',
		'整改人':'整改人',
		'整改时间':'整改时间',
		'整改值':'整改值',
		'整改措施':'整改措施',
		'整改结果':'整改结果',
		'整改反馈':'整改反馈',
		'验收人':'验收人',
		'验收时间':'验收时间',
		'验收值':'验收值',
		'验收情况':'验收情况',
		'验收结果':'验收结果',
		'验收反馈':'验收反馈',
		'添加安全分析':'添加安全分析',
		'安全分析':'安全分析',
		'查看':'查看',
		'请输入JSA编码':'请输入JSA编码',
		'请选择作业单位':'请选择作业单位',
		'请输入分析组长':'请输入分析组长',
		'JSA编码':'JSA编码',
		'作业单位':'作业单位',
		'作业日期':'作业日期',
		'作业地点':'作业地点',
		'作业内容':'作业内容',
		'JSA安全分析':'JSA安全分析',
		'分析组长':'分析组长',
		'分析组员':'分析组员',
		'作业类型':'作业类型',
		'作业环节':'作业环节',
		'风险内容':'风险内容',
		'风险结果':'风险结果',
		'安全措施':'安全措施',
		'JSA组织人':'JSA组织人',
		'请选择作业申请人':'请选择作业申请人',
		'请输入预约单号':'请输入预约单号',
		'预约单号':'预约单号',
		'预约作业时间':'预约作业时间',
		'申请单位':'申请单位',
		'作业申请人':'作业申请人',
		'作业监护人':'作业监护人',
		'作业方':'作业方',
		'现场联系人':'现场联系人',
		'现场联系电话':'现场联系电话',
		'作业级别':'作业级别',
		'申请作业票':'申请作业票',
		'申请票号':'申请票号',
		'作业名称':'作业名称',
		'涉及其它作业':'涉及其它作业',
		'JSA分析':'JSA分析',
		'作业开始时间':'作业开始时间',
		'作业结束时间':'作业结束时间',
		'申请人':'申请人',
		'申请状态':'申请状态',
		'提交':'提交',
		'作业证类型':'作业证类型',
		'请选择':'请选择',
		'重新选择':'重新选择',
		'涉及其他作业':'涉及其他作业',
		'审批环节':'审批环节',
		'审批人':'审批人',
		'作业时间':'作业时间',
		'作业负责人':'作业负责人',
		'作业负责人手机号':'作业负责人手机号',
		'上传':'上传',
		'动火方式':'动火方式',
		'监护人':'监护人',
		'动火初审人':'动火初审人',
		'作业人员':'作业人员',
		'作业位置':'作业位置',
		'作业位置签到范围（米）':'作业位置签到范围（米）',
		'风险识别':'风险识别',
		'应急措施':'应急措施',
		'作业分析人':'作业分析人',
		'现场安全确认人':'现场安全确认人',
		'安全交底人':'安全交底人',
		'作业验收人':'作业验收人',
		'作业围栏':'作业围栏',
		'绘制围栏':'绘制围栏',
		'离岗报警':'离岗报警',
		'围栏人员':'围栏人员',
		'上一步':'上一步',
		'保存':'保存',
		'保存并进入下一步':'保存并进入下一步',
		'保存并提交审批':'保存并提交审批',
		'请选择JSA分析':'请选择JSA分析',
		'作业审批选择':'作业审批选择',
		'请输入审批名称':'请输入审批名称',
		'模板':'模板',
		'其他':'其他',
		'审批部门查看':'审批部门查看',
		'开始':'开始',
		'默认':'默认',
		'流程结束':'流程结束',
		'作业管控查看':'作业管控查看',
		'审批名称':'审批名称',
		'属性':'属性',
		'作业分析':'作业分析',
		'作业票号':'作业票号',
		'申请时间':'申请时间',
		'审批流程':'审批流程',
		'作业票状态':'作业票状态',
		'作业审批查看':'作业审批查看',
		'作业信息':'作业信息',
		'现场分析':'现场分析',
		'现场安全确认':'现场安全确认',
		'作业审批':'作业审批',
		'现场安全交底':'现场安全交底',
		'现场实施':'现场实施',
		'作业结束确认':'作业结束确认',
		'作业验收存档':'作业验收存档',
		'签到范围':'签到范围',
		'作业电子围栏':'作业电子围栏',
		'围栏报警':'围栏报警',
		'申请附件':'申请附件',
		'分析记录':'分析记录',
		'仪器名称':'仪器名称',
		'仪器型号':'仪器型号',
		'采样点':'采样点',
		'分析内容':'分析内容',
		'分析结果':'分析结果',
		'正常':'正常',
		'异常':'异常',
		'分析时间':'分析时间',
		'分析人':'分析人',
		'现场分析人':'现场分析人',
		'签名时间':'签名时间',
		'存档附件':'存档附件',
		'票证导出':'票证导出',
		'结果':'结果',
		'措施内容':'措施内容',
		'确认角色':'确认角色',
		'应急内容':'应急内容',
		'审批意见':'审批意见',
		'安全交底清单':'安全交底清单',
		'接受交底人':'接受交底人',
		'字典类型':'字典类型',
		'标签':'标签',
		'值':'值',
		'排序':'排序',
		'是否默认':'是否默认',
		'作业时间不能超过':'作业时间不能超过',
		'小时（最大72小时）':'小时（最大72小时）',
		'现场分析应在作业开始前':'现场分析应在作业开始前',
		'分钟执行（最大60分钟）':'分钟执行（最大60分钟）',
		'安全措施内容':'安全措施内容',
		'应急措施内容':'应急措施内容',
		'设备ID':'设备ID',
		'推送服务器地址':'推送服务器地址',
		'推送服务器端口':'推送服务器端口',
		'推送服务器验证':'推送服务器验证',
		'GPU':'GPU',
		'视频分析设备':'视频分析设备',
		'编号':'编号',
		'名称':'名称',
		'端口':'端口',
		'流协议类型':'流协议类型',
		'视频流地址':'视频流地址',
		'摄像头账号':'摄像头账号',
		'摄像头密码':'摄像头密码',
		'分辨率':'分辨率',
		'识别算法':'识别算法',
		'间隔时间（S）':'间隔时间（S）',
		'视频流path':'视频流path',
		'报警时间':'报警时间',
		'分析设备':'分析设备',
		'监控名称':'监控名称',
		'报警图片':'报警图片',
		'报警视频':'报警视频',
		'处理状态':'处理状态',
		'销警时间':'销警时间',
		'销警反馈':'销警反馈',
		'销警人':'销警人',
		'销警':'销警',
		'菜单名称':'菜单名称',
		'菜单类型':'菜单类型',
		'路由类型':'路由类型',
		'显示顺序':'显示顺序',
		'描述':'描述',
		'目录':'目录',
		'菜单':'菜单',
		'按钮':'按钮',
		'路由':'路由',
		'内链':'内链',
		'外链':'外链',
		'图标':'图标',
		'路由地址':'路由地址',
		'角色名':'角色名',
		'权限字符':'权限字符',
		'权限配置':'权限配置',
		'菜单权限':'菜单权限',
		'App授权':'App授权',
		'登录名':'登录名',
		'角色':'角色',
		'重置密码':'重置密码',
		'绑定人员':'绑定人员',
		'解绑人员':'解绑人员',
		'人员注册':'人员注册',
		'人员批量注册':'人员批量注册',
		'岗位':'岗位',
		'密码':'密码',
		'确认密码':'确认密码',
		'角色选择':'角色选择',
		'角色配置':'角色配置',
		'新增用户':'新增用户',
		'编辑用户':'编辑用户',
		'修改密码':'修改密码',
		'6-20以上的字母加数字的密码组合':'6-20以上的字母加数字的密码组合',
		'部门ID':'部门ID',
		'电话':'电话',
		'岗位名':'岗位名',
		'岗位职责':'岗位职责',
		'左键拖动地图，鼠标滚轮放大缩小，右键绘制围栏':'左键拖动地图，鼠标滚轮放大缩小，右键绘制围栏',
		'实时演练':'实时演练',
		'未开始':'未开始',
		'进行中':'进行中',
		'已结束':'已结束',
		'已完成':'已完成',
		'未巡检':'未巡检',
		'巡检中':'巡检中',
		'逾期未完成':'逾期未完成',
		'未完成':'未完成',
		'出厂':'出厂',
		'批量绑定':'批量绑定',
		'批量解绑':'批量解绑',
		'演练名称':'演练名称',
		'参与部门':'参与部门',
		'演练地点':'演练地点',
		'演练日期':'演练日期',
		'集合开始时间':'集合开始时间',
		'集合结束时间':'集合结束时间',
		'演练状态':'演练状态',
		'相关部门':'相关部门',
		'楼层':'楼层',
		'参演人数':'参演人数',
		'实到人数':'实到人数',
		'评审人员':'评审人员',
		'过程记录':'过程记录',
		'演练效果':'演练效果',
		'上传附件':'上传附件',
		'集合状态':'集合状态',
		'模型':'模型',
		'倾斜':'倾斜',
		'地图地址':'地图地址',
		'经度/X偏移':'经度/X偏移',
		'纬度/Y偏移':'纬度/Y偏移',
		'高度/Z偏移':'高度/Z偏移',
		'是否拖动':'是否拖动',
		'点击经度':'点击经度',
		'点击纬度':'点击纬度',
		'加载地图':'加载地图',
		'保存配置':'保存配置',
		'绘制完成':'绘制完成',
		'取消':'取 消',
		'系统信息管理':'系统信息管理',
		'系统名称':'系统名称',
		'LOGO':'LOGO',
		'底图类型':'底图类型',
		'默认路由':'默认路由',
		'3D':'3D',
		'2.5D':'2.5D',
		'2D':'2D',
		'地图范围':'地图范围',
		'绘制':'绘制',
		'置空':'置空',
		'保存并刷新':'保存并刷新',
		'关闭':'关闭',
		'天地图':'天地图',
		'WMTS在线服务':'WMTS在线服务',
		'配置名称':'配置名称',
		'配置值':'配置值',
		'登录用户':'登录用户',
		'登录状态':'登录状态',
		'终端地址':'终端地址',
		'操作人':'操作人',
		'操作时间':'操作时间',
		'操作名称':'操作名称',
		'操作类型':'操作类型',
		'请求方式':'请求方式',
		'请求方法':'请求方法',
		'返回结果':'返回结果',
		'操作状态':'操作状态',
		'客户端地址':'客户端地址',
		'其它':'其它',
		'修改':'修改',
		'删除':'删除',
		'授权':'授权',
		'导出':'导 出',
		'导入':'导入',
		'强退':'强退',
		'生成代码':'生成代码',
		'清空数据':'清空数据',
		'已处理':'已处理',
		'在职':'在职',
		'离职':'离职',
		'未离开':'未离开',
		'已离开':'已离开',
		'使用':'使用',
		'未使用':'未使用',
		'无线基站':'无线基站',
		'局域网基站':'局域网基站',
		'动火作业':'动火作业',
		'吊装作业':'吊装作业',
		'动土作业':'动土作业',
		'断路作业':'断路作业',
		'高处作业':'高处作业',
		'设备检修作业':'设备检修作业',
		'盲板抽堵作业':'盲板抽堵作业',
		'受限空间作业':'受限空间作业',
		'二级动火作业':'二级动火作业',
		'一级动火作业':'一级动火作业',
		'特殊动火作业':'特殊动火作业',
		'三级吊装作业':'三级吊装作业',
		'二级吊装作业':'二级吊装作业',
		'一级吊装作业':'一级吊装作业',
		'三级高处作业':'三级高处作业',
		'二级高处作业':'二级高处作业',
		'一级高处作业':'一级高处作业',
		'特级高处作业':'特级高处作业',
		'全厂人数':'全厂人数',
		'楼层选择':'楼层选择',
		'监控':'监控',
		'重大风险分区':'重大风险分区',
		'人员类别统计':'人员类别统计',
		'人员类别环比':'人员类别环比',
		'重大风险分区统计':'重大风险分区统计',
		'区域统计':'区域统计',
		'批量处理报警记录':'批量处理报警记录',
		'报警类别':'报警类别',
		'报警内容':'报警内容',
		'处理反馈':'处理反馈',
		'新增员工':'新增员工',
		'查看员工':'查看员工',
		'编辑员工':'编辑员工',
		'导入员工':'导入员工',
		'新增访客':'新增访客',
		'编辑访客':'编辑访客',
		'查看访客':'查看访客',
		'导入访客':'导入访客',
		'新增信息':'新增信息',
		'编辑信息':'编辑信息',
		'查看信息':'查看信息',
		'导入信息':'导入信息',
		'新增区域':'新增区域',
		'个人设置':'个人设置',
		'服务器配置':'服务器配置',
		'换肤':'换肤',
		'退出登录':'退出登录',
		'在线人数':'在线人数',
		'人员':'人员',
		'摄像头':'摄像头',
		'地图':'地图',
		'列表':'列表',
		'全屏':'全屏',
		'人数':'人数',
		'人员、车辆实时分析':'人员、车辆实时分析',
		'部门实时分析':'部门实时分析',
		'人员周统计':'人员周统计',
		'今日人员报警':'今日人员报警',
		'今日车辆报警':'今日车辆报警',
		'今日区域报警':'今日区域报警',
		'区域人员实时分析':'区域人员实时分析',
		'分区名称':'分区名称',
		'总人数':'总人数',
		'卡号':'卡号',
		'追踪':'追踪',
		'报警位置':'报警位置',
		'报警描述':'报警描述',
		'处理时间':'处理时间',
		'处理人':'处理人',
		'速度':'速度',
		'人员类别':'人员类别',
		'人员状态':'人员状态',
		'工作单位':'工作单位',
		'来访时间':'来访时间',
		'离开时间':'离开时间',
		'来访状态':'来访状态',
		'是否加入黑名单':'是否加入黑名单',
		'审批':'审批',
		'员工类型':'员工类型',
		'员工状态':'员工状态',
		'电量':'电量',
		'定位设备类型':'定位设备类型',
		'电量(%)':'电量(%)',
		'信标编码':'信标编码',
		'衰减度':'衰减度',
		'一米信号强弱':'一米信号强弱',
		'传输状态':'传输状态',
		'大屏展示':'大屏展示',
		'取消追踪':'取消追踪',
		'查询':'查 询',
		'批量处理':'批量处理',
		'批量删除':'批量删除',
		'确定':'确 定',
		'选择文件':'选择文件',
		'开始导入':'开始导入',
		'下载模板':'下载模板',
		'信标位置管理':'信标位置管理',
		'基站位置管理':'基站位置管理',
		'楼宇位置管理':'楼宇位置管理',
		'摄像头位置管理':'摄像头位置管理',
		'返回厂区':'返回厂区',
		'添加信标':'添加信标',
		'同步':'同步',
		'下载二维码':'下载二维码',
		'导入提示1':'1、请选择EXCEL文件(.xlsx或.xls)，并严格按照模板示例格式导入，标红为必填项；',
		'导入提示2':'2、系统将自动过滤表格中重复、不符合要求、系统中已存在的数据；',
		'导入提示3':'3、为了保证系统数据不被误覆盖，导入模式不采用更新已存在数据进行；',
		'账号不能为空':'账号不能为空',
		'密码不能为空':'密码不能为空',
		'验证码不能为空':'验证码不能为空'
	},
	'单位':{
		'人':'人',
		'/人':'/人',
		'次':'次',
		'个':'个'
	}
}


// WEBPACK FOOTER //
// ./src/i18n/lang/zh.js